var React = require('react');

function ArrowTealInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.4343 0.156968L12.5576 1.03353C12.3453 1.24581 12.3488 1.5911 12.5653 1.79905L16.1711 5.26125H0.76945C0.473415 5.26125 0.233398 5.50122 0.233398 5.7972V7.04777C0.233398 7.34375 0.473415 7.58373 0.76945 7.58373H16.1711L12.5654 11.0459C12.3488 11.2539 12.3453 11.5992 12.5577 11.8114L13.4344 12.688C13.6437 12.8973 13.9831 12.8973 14.1925 12.688L20.0801 6.80145C20.2894 6.59216 20.2894 6.25281 20.0801 6.04347L14.1924 0.156968C13.9831 -0.0523228 13.6437 -0.0523228 13.4343 0.156968Z","fill":"#6DDDD7"}));
}

ArrowTealInline.defaultProps = {"width":"21","height":"13","viewBox":"0 0 21 13","fill":"none"};

module.exports = ArrowTealInline;

ArrowTealInline.default = ArrowTealInline;
